import Make from './../components/MakeSection/Make';
import FAQs from '../components/FAQsSection/FAQs';
import ServicesSection from '../components/ServicesSection/ServicesSection';
import History from '../components/HistorySection/History';
import Description from '../components/DescriptionSection/Description';
import HeroSection from '../components/HeroSection/HeroSection';
import SEO from '../components/SEO/SEO';
import { usePageSEO } from '../hooks/usePageSEO';

const B2B = () => {
  const seo = usePageSEO('b2b');

  return (
    <>
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        type={seo.type}
        noIndex={seo.noIndex}
        noFollow={seo.noFollow}
      />
      <HeroSection page="B2BPage" showRecentWork={false} showMoreButton={true} />
      <ServicesSection page="B2BPage" />
      <History pageKey="B2BPage" />
      <Description page="B2BPage" />
      <FAQs page='b2bPage' />
      <Make pageKey='b2bPage' />
    </>
  );
};

export default B2B;